var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.template)?_c('content-preview-page',{attrs:{"content":_vm.template,"title":_vm.template.name,"description":_vm.template.description}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }